import { AdapterOptions } from './analyticsService.d';

const dataConverter = (
  source,
): { [key: string]: string | number | boolean } => {
  const dataEntries = Object.entries(source);

  const convertedData = dataEntries.reduce((acc, [key, value]) => {
    if (['string', 'number', 'boolean'].includes(typeof value)) {
      acc[key] = value;
    }
    return acc;
  }, {});

  return convertedData;
};

const titleRouteConfig: Array<{ title: string; route: RegExp }> = [
  { title: 'Map Screen', route: /^#\/where/ },
  { title: 'Confirm Address Screen', route: /^#\/delivery\/confirm/ },
  {
    title: 'Delivery/Collection Restaurants List',
    route: /^#\/(collection|delivery)/,
  },
  { title: 'Phone Number Screen', route: /^#\/phone/ },
  {
    title: 'Restaurant Menu Screen',
    route: /^#\/restaurant/,
  },
  { title: 'SMS Code Screen', route: /^#\/code/ },
  { title: 'Payments Screen', route: /^#\/payment/ },
  { title: 'Add New Card Screen', route: /^#\/card/ },
  { title: 'Checkout Screen', route: /^#\/checkout/ },
  { title: 'Add Voucher Screen', route: /^#\/voucher/ },
  { title: 'Order Placed Screen', route: /^#\/order/ },
];

function getTitleFromRoute(hashRoute: string): string {
  try {
    const { title } = titleRouteConfig.find(({ route }) =>
      route.test(hashRoute),
    );
    return title;
  } catch (error) {
    return '';
  }
}

function getSpecificVendorData(
  vendorCode: string,
  data: Record<string, unknown>,
): Record<string, unknown> {
  const prefix = `${vendorCode}_`;
  const customData = Object.entries(data).reduce((acc, [key, value]) => {
    if (key.startsWith(prefix)) {
      const cleanKey = key.replace(prefix, '');
      acc[cleanKey] = value;
    }

    return acc;
  }, {});

  return customData;
}

function getGenericData(
  data: Record<string, unknown>,
): Record<string, unknown> {
  const customData = Object.entries(data).reduce((acc, [key, value]) => {
    if (!key.includes('_')) {
      acc[key] = value;
    }
    return acc;
  }, {});

  return customData;
}

const serviceOptions: AdapterOptions = {
  debug: false,
  logger: (message) => console.log(`AnalyticsService: ${message}`),
};

export const analyticsUtils = {
  dataConverter,
  getGenericData,
  getSpecificVendorData,
  getTitleFromRoute,
  serviceOptions,
};
